<template>
  <h1>Configure Example Widget</h1>
</template>

<script>
export default {
  //
}
</script>
